import { render, staticRenderFns } from "./PaymentMethodInfo.vue?vue&type=template&id=7706ecf2&"
import script from "./PaymentMethodInfo.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports